import { render, staticRenderFns } from "./APMAComment.vue?vue&type=template&id=9e61d4fc&"
import script from "./APMAComment.vue?vue&type=script&lang=js&"
export * from "./APMAComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports